import {
  base_colorAlert,
  base_colorContentBorder,
  base_colorRaisedSurface,
  blue300,
  cta_buttonPrimaryBackground,
  green300,
  grey400,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_4xl,
  font_family_weight_medium,
  font_family_weight_regular,
  font_lg,
  font_md,
  font_sm,
  font_xl,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  &.InsightsTileRenderer {
    background: ${base_colorRaisedSurface};
    border: 1px solid ${base_colorContentBorder};
    border-radius: 8px;
    padding: ${spacing(5)};
    margin-bottom: ${spacing(4)};

    /* Reusable text styles */
    .label {
      font-family: ${font_family_weight_regular};
      ${font_md};
      color: ${text_colorTextSecondary};
    }

    .number {
      font-family: ${font_family_weight_medium};
      ${font_xl};
      color: ${text_colorTextPrimary};
    }

    .number-large {
      font-family: ${font_family_weight_medium};
      ${font_4xl};
      color: ${text_colorTextPrimary};
    }

    .number-accent {
      font-family: ${font_family_weight_medium};
      ${font_4xl};
      color: ${cta_buttonPrimaryBackground};
    }

    .item-title {
      font-family: ${font_family_weight_medium};
      ${font_lg};
      color: ${text_colorTextPrimary};
    }

    /* Card styles */
    .card {
      padding: ${spacing(3)} ${spacing(4)};
      background: ${base_colorRaisedSurface};
      border: 1px solid ${base_colorContentBorder};
      border-radius: 6px;
      transition: all 0.2s ease;
    }

    .section {
      padding: ${spacing(4)};
      background: ${base_colorRaisedSurface};
      border: 1px solid ${base_colorContentBorder};
      border-radius: 6px;
    }

    .divider {
      border-top: 1px solid ${base_colorContentBorder};
      margin: ${spacing(4)} 0;
    }

    .tile-header {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: ${spacing(3)};

      .tile-title {
        font-family: ${font_family_weight_medium};
        ${font_lg};
        color: ${text_colorTextPrimary};
        margin: 0;
      }

      .tile-pin-button {
        border: none;
        background: transparent;
        padding: ${spacing(1)};
        margin: -${spacing(1)};
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        color: ${text_colorTextSecondary};
        transition: color 0.2s ease;

        &:hover,
        &:focus-visible {
          color: ${text_colorTextPrimary};
          outline: none;
        }

        &.pinned {
          color: ${text_colorTextPrimary};
        }
      }
    }

    .tile-content {
      min-height: 150px;

      &.loading,
      &.error,
      &.empty {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: ${spacing(6)};
        color: ${text_colorTextSecondary};
        font-family: ${font_family_weight_medium};
        ${font_md};
        text-align: center;
      }

      &.error {
        color: ${base_colorAlert};
      }

      /* Number Card */
      &.number-card {
        .gradient-border {
          height: 4px;
          background: linear-gradient(
            to right,
            ${green300} 0%,
            ${blue300} 100%
          );
          margin: -${spacing(5)} -${spacing(5)} ${spacing(4)} -${spacing(5)};
        }

        .period-column {
          flex-basis: 33%;
          display: flex;
          flex-direction: column;
          gap: ${spacing(2)};
          padding: ${spacing(4)};

          .period-dates {
            ${font_md};
            color: ${text_colorTextSecondary};
          }

          &:not(:first-child) {
            border-left: 1px solid ${base_colorContentBorder};
          }
        }

        .number-accent {
          color: ${green300};
        }
      }

      /* Leaderboard */
      &.leaderboard {
        .rank-badge {
          display: flex;
          align-items: center;
          justify-content: center;
          min-width: 36px;
          height: 36px;
          border-radius: 50%;
          font-family: ${font_family_weight_medium};
          ${font_md};
          background: ${grey400};
          color: ${text_colorTextPrimary};
        }
      }
    }

    /* Graph tooltip styles */
    .graph-tooltip {
      .tooltip-header {
        font-weight: 600;
        margin-bottom: ${spacing(1)};
      }

      .tooltip-date-range {
        ${font_sm};
        color: ${text_colorTextSecondary};
        margin-bottom: ${spacing(1)};
      }

      .tooltip-value {
        ${font_md};
        color: ${text_colorTextPrimary};
      }
    }

    .chart-wrapper {
      margin-top: ${spacing(4)};
    }
  }
`
